import React from 'react'
import Helmet from 'react-helmet'
import NavigationMenuScrollSpy from '../../components/NavigationMenuScrollSpy/index.js'
import Footer from '../../components/Footer/index.js'

import "../../styles/main.scss";


class HomeLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      description: props.description,
      keywords: props.keywords,
      children: props.children,
    };
  }

  componentDidMount() {
    if (window.location.hash) {
      setTimeout(() => {
        document.querySelector(`${window.location.hash}`).scrollIntoView();
      }, 0);
    }
  }

  render() {

    return (
      <>
        <Helmet
          title={this.state.title}
          meta={[
            { name: 'description', content: this.state.description },
            { name: 'keywords', content: this.state.keywords },
          ]}
        >
          <html lang="fr" />
        </Helmet>
        <div className="bodywrapper">
          <NavigationMenuScrollSpy />
          {this.state.children}
          <Footer/>
        </div>
      </>
    );
  }


}

export default HomeLayout;